import { get } from 'utils/apiHelper'

export const getDoorKnockerInfo = (shipmentPin, lang, retailCode) =>
  get({
    path: `/cans/api/doorknocker?pin=${shipmentPin}&retailCode=${retailCode}&language=${lang}&`,
  })

// cans/api/doorknocker?pin=607814240075&retailCode=RA5133&language=fr&
